import { ref } from '@vue/composition-api'
import { TYPES, STATUSES } from '@/shared/constants/questionnaire'
import router from '@/shared/router'
import { fetchAnswersByQuestionnaireId, fetchQuestionnaire } from '@/shared/services/questionnaireService'
import moment from 'moment'

export default function useQuestionnaireView() {
  const questionnaire = ref(null)
  const currentPage = ref(1)
  const limitPerPage = 4
  const totalRows = Math.round(Math.random() * 15)
  const answers = ref([])

  const getChoiceQuestionAnswers = documentItem => {
    const { uuid, type, content } = documentItem

    return content.map(contentItem => {
      const { label } = contentItem
      const users = []

      answers.value.forEach(answerItem => {
        const questionniareItem = answerItem.questionnaire.find(
          item => item.questionId === uuid,
        )

        // If exist, then handle with type of question and push user to users array
        if (questionniareItem) {
          if (type === TYPES.MULTIPLE) {
            questionniareItem.answer.forEach(answer => {
              if (label === answer) { users.push(answerItem.user) }
            })
          } else if (label === questionniareItem.answer) users.push(answerItem.user)
        }
      })

      return { ...contentItem, users }
    })
  }

  const getTextQuestionAnswers = documentItem => {
    const { uuid } = documentItem
    const content = []

    answers.value.forEach(answerItem => {
      // Find answer record has question id is documentItem.uuid
      const questionniareItem = answerItem.questionnaire.find(
        item => item.questionId === uuid,
      )
      // If exist, then push content, user, date of answer to content array
      if (questionniareItem) {
        content.push({
          label: questionniareItem.answer,
          user: answerItem.user,
          date: answerItem.date,
        })
      }
    })

    // Array answers with text question type
    return content
  }

  const getDateQuestionAnswers = documentItem => {
    const { uuid, type } = documentItem
    const contentAnswers = {}

    answers.value.forEach(answerItem => {
      // Find answer record has question id is documentItem.uuid
      const questionniareItem = answerItem.questionnaire.find(
        item => item.questionId === uuid,
      )

      const YYYYMMDD = moment(type === TYPES.DATE ? questionniareItem.answer.toDate() : questionniareItem.answer.startingDay.toDate()).format('YYYYMMDD')

      if (YYYYMMDD in contentAnswers) {
        // If type is date then push user
        // else type is range then push user has additional startingDay, endingDay field
        contentAnswers[YYYYMMDD].push(type === TYPES.DATE ? answerItem.user : {
          ...answerItem.user,
          startingDay: questionniareItem.answer.startingDay,
          endingDay: questionniareItem.answer.endingDay,
        })
      } else { // else create new array values
        contentAnswers[YYYYMMDD] = [type === TYPES.DATE ? answerItem.user : {
          ...answerItem.user,
          startingDay: questionniareItem.answer.startingDay,
          endingDay: questionniareItem.answer.endingDay,
        }]
      }
    })

    return contentAnswers
  }

  const fetchData = async () => {
    const { id } = router.currentRoute.params
    answers.value = await fetchAnswersByQuestionnaireId(id)

    // Fetch questionnaire data
    fetchQuestionnaire(id)
      .then(async res => {
        // Loop with every questionnaire to get answer of users
        const document = await Promise.all(
          res.document.map(documentItem => {
            const { type } = documentItem
            let { content } = documentItem

            if (type === TYPES.MULTIPLE || type === TYPES.SINGLE) {
              content = getChoiceQuestionAnswers(documentItem)
            } else if (type === TYPES.TEXT_SHORT || type === TYPES.TEXT_LONG) {
              content = getTextQuestionAnswers(documentItem)
            } else if (type === TYPES.DATE || type === TYPES.RANGE) {
              // eslint-disable-next-line no-param-reassign
              documentItem.answers = getDateQuestionAnswers(documentItem)
            }

            return { ...documentItem, content }
          }),
        )
        questionnaire.value = { ...res, id, document }
      })
  }

  return {
    questionnaire,
    currentPage,
    limitPerPage,
    totalRows,
    TYPES,
    STATUSES,

    fetchData,
  }
}
